import {
  HOUR,
  isDefined,
  messageFromError,
  type RoleId,
  type TeamGetInput,
  type TeamGetSuccess,
  type TeamId,
  type UserId,
} from '@terros/common'
import { useQueries } from '@tanstack/react-query'
import { teamKey } from '../keys'
import { useServerRequest } from '../api'

export type UserTeamMembership = {
  teamId: TeamId
  roleIds: RoleId[]
}

type Result = {
  error?: string
  memberships: UserTeamMembership[]
  isLoading: boolean
}

export function useUserTeamMemberships(userId: UserId | undefined, teamIds: TeamId[]): Result {
  const serverRequest = useServerRequest<TeamGetInput, TeamGetSuccess>('/team/get')

  return useQueries({
    queries: teamIds.map((teamId) => ({
      queryKey: teamKey(teamId),
      queryFn: () => serverRequest({ teamId }),
      staleTime: HOUR,
      gcTime: HOUR,
      enabled: isDefined(userId),
    })),
    combine: (results) => ({
      error: messageFromError(results.find((result) => result.error)?.error),
      memberships: results.map((result, i) => {
        const teamId = teamIds[i]
        const member = result.data?.members.find((m) => m.user.userId === userId)
        return { teamId, roleIds: member?.roleIds ?? [] }
      }),
      isLoading: results.some((r) => r.isLoading),
    }),
  })
}
